import { Component, OnInit } from '@angular/core';

import { ErrorModel, UserImageModel } from '@core/api';
import { UserService } from '@accounts/user/services/user.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { finalize } from 'rxjs/operators';
import { of } from 'rxjs/index';
import { HttpStatusCode } from '@core/enums/http-status-code';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormService } from '@core/services';

@Component({
  selector: 'user-passport',
  templateUrl: './user-passport.component.html',
  styleUrls: ['./user-passport.component.scss']
})
export class UserPassportComponent implements OnInit {
  allowedTypes = [
    {
      type: UserImageModel.TypeEnum.PassportIdentityPage,
      label: this.i18n('Паспорт стр.32-33')
    },
    {
      type: UserImageModel.TypeEnum.PassportSignPage,
      label: this.i18n('Паспорт стр.31')
    },
    {
      type: UserImageModel.TypeEnum.PassportRegistrationPage,
      label: this.i18n('Регистрация')
    },
    {
      type: UserImageModel.TypeEnum.PassportSelfie,
      label: this.i18n('Селфи с документом')
    }
  ];

  imageTypes: typeof UserImageModel.TypeEnum;

  form: FormGroup = this.formBuilder.group({
    [UserImageModel.TypeEnum.PassportIdentityPage]: [null],
    [UserImageModel.TypeEnum.PassportSignPage]: [null],
    [UserImageModel.TypeEnum.PassportRegistrationPage]: [null],
    [UserImageModel.TypeEnum.PassportSelfie]: [null]
  });

  constructor(
    private formBuilder: FormBuilder,
    private formService: FormService,
    private userService: UserService,
    private i18n: I18n
  ) {
    this.imageTypes = UserImageModel.TypeEnum;
  }

  selectFile({ image, type, start, stop }) {
    start();

    this.form.get(type).setValue(image);

    this.userService.uploadImage({
      image,
      type
    })
      .pipe(finalize(stop))
      .subscribe(res => {
        stop();
      }, error => {
        if (error.status === HttpStatusCode.UNPROCESSABLE_ENTITY) {

          error.errors[type] = error.errors && error.errors.image;

          this.formService.serverValidateForm(this.form, error);
        }
      });
  }

  ngOnInit() {
    this.userService.getImages();
  }

}
